import CommissionsList from "../views/CommissionsList"
import CommissionsCreate from "../views/CommissionsCreate"

export default [
	{
		path: "/:tenantId/commissions",
		component: CommissionsList,
		name: "CommissionsList",
		meta: { featureId: "commissions" },
		props: true
	},
	{
		path: "/:tenantId/commissions/create-update/:id?",
		component: CommissionsCreate,
		name: "CommissionsCreate",
		meta: { featureId: "commissions" },
		props: true
	}
]
